import React from 'react';

const variants = {
  success: 'bg-camp-100 text-camp-800',
  warning: 'bg-amber-100 text-amber-800',
  danger: 'bg-red-100 text-red-700',
  info: 'bg-blue-100 text-blue-700',
  neutral: 'bg-gray-100 text-gray-700',
};

export default function CampBadge({
  children,
  variant = 'neutral',
  className = '',
  ...props
}) {
  return (
    <span
      className={[
        'inline-flex items-center rounded-full px-2.5 py-1',
        'text-xs font-semibold',
        variants[variant] || variants.neutral,
        className,
      ].join(' ')}
      {...props}
    >
      {children}
    </span>
  );
}
